import React, { useEffect, useContext, useState } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArchive,
  faBarcode,
  faCircleXmark,
  faCube,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import "./Product.css";
import { Context } from "../../../../utils/context";
import { useLocation } from "react-router-dom";
import { useFieldArray, useForm, useWatch } from "react-hook-form";
import { getData } from "../../../../utils/api";
import Summary from "../Summary/Summary";
import LensModal from "../LensModal/LensModal";
import { faProductHunt } from "@fortawesome/free-brands-svg-icons";
import { Category, Select2Data } from "../../../../utils/common";
import Lense_prescription_modal from "../LensModal/prescription_modal";

function Product({ user_id }) {
  const { toggleSidebarFalse, IMG_URL } = useContext(Context);

  const [lensModalShow, setLensModalShow] = useState(false);
  const [lensIndex, setLensIndex] = useState("");
  const [PrescriptionModel, setPrescriptionModel] = useState(false);
  const [prescription, setPrescription] = useState(false);

  const { control, register, handleSubmit, watch, setValue, getValues } =
    useForm({
      defaultValues: {
        products: [{ barcode_no: "", model: "", product_details: "" }],
      },
    });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "products",
  });

  const onSubmit = (data) => {
    console.log("Product Search Input:", data);
  };

  const [productId, setProductId] = useState([{}]);

  const getProductDetails = async (index) => {
    const barcode_no = watch(`products.${index}.barcode_no`);
    const p_category_id = watch(`products.${index}.p_category_id`);
    const name = watch(`products.${index}.name`);
    const model = watch(`products.${index}.model`);
    const bo_code = watch(`products.${index}.bo_code_product`);

    const res = await getData(
      `/admin/offline-order/getBarModProduct?barcode_no=${
        barcode_no || ""
      }&model=${model || ""}&p_category_id=${p_category_id || ""}&name=${
        name || ""
      }&bo_code=${bo_code || ""}`,
    );
    if (res.success) {
      await setValue(`products.${index}.product_details`, res.data);
    } else {
      await setValue(`products.${index}.product_details`, "");
      console.warn("❌ Product not found");
    }
  };

  const handleAddLens = async (index) => {
    if (!user_id) {
      alert("Please Add User Details...!");
      return false;
    }
    await setLensModalShow(true);
    await setLensIndex(index);
  };

   const handleprescription = async (index) => {
    if (!user_id) {
      alert("Please Add User Details...!");
      return false;
    }
    // await setLensModalShow(true);
    await setLensIndex(index);
  };

  const [categories, setCategories] = useState([]);

  const getAllCategories = async () => {
    const response = await getData("/common/masters/all-p-category?admin=true");
    if (response?.success) {
      setCategories(await Select2Data(response.data, "p_category_id"));
    }
  };

  useEffect(() => {
    getAllCategories();
  }, []);

  useEffect(() => {
    const subscription = watch((value, { name }) => {
      if (
        name &&
        name.includes("products") &&
        (name.endsWith("barcode_no") ||
          name.endsWith("model") ||
          name.endsWith("name") ||
          name.endsWith("bo_code_product") ||
          name.endsWith("p_category_id"))
      ) {
        const match = name.match(/products\.(\d+)\./);
        if (match) {
          const index = parseInt(match[1], 10);
          getProductDetails(index);
        }
      }
    });

    return () => subscription.unsubscribe();
  }, [watch, prescription]);

  const handleRemoveProduct = (index) => {
    setValue(`products.${index}.product_details`, null);
    // setValue(`products.${index}.product_details.lens_details`, null);
    // setValue(`products.${index}.product_details.addon_details`, null);
  };

  const handleRemoveLens = (index) => {
    setValue(`products.${index}.product_details.lens_details`, null);
  };
  const handleRemoveAdd = (index) => {
    setValue(`products.${index}.product_details.addon_details`, null);
  };

  return (
    <>
      <Row>
        <Col md={8}>
          <section className="product-container">
            <h4 className="product-title">Products</h4>

            <Form onSubmit={handleSubmit(onSubmit)}>
              {fields.map((item, index) => (
                <Row key={index} className="mb-4">
                  <Col md={12}>
                    <div className="product-input-wrapper p-4 shadow rounded bg-white position-relative">
                      <Row className="align-items-start g-3 mb-4">
                        <Col md={8}>
                          <Form.Group>
                            <div className="input-icon d-flex align-items-center">
                              <FontAwesomeIcon
                                icon={faArchive}
                                className="icon me-2"
                              />
                              <Form.Select
                                {...register(`products.${index}.p_category_id`)}
                                className="user-input"
                              >
                                {categories.map((cat) => (
                                  <option key={cat.value} value={cat.value}>
                                    {cat.label}
                                  </option>
                                ))}
                              </Form.Select>
                            </div>
                          </Form.Group>
                        </Col>

                        {watch(`products.${index}.p_category_id`) && (
                          <>
                            {(watch(`products.${index}.p_category_id`) ==
                              Category?.Eyeglasses ||
                              watch(`products.${index}.p_category_id`) ==
                                Category?.Sunglasses) && (
                              <>
                                <Col md={5}>
                                  <Form.Group>
                                    <div className="input-icon d-flex align-items-center">
                                      <FontAwesomeIcon
                                        icon={faBarcode}
                                        className="icon me-2"
                                      />
                                      <Form.Control
                                        type="text"
                                        placeholder="Barcode"
                                        {...register(
                                          `products.${index}.barcode_no`,
                                        )}
                                        className="user-input"
                                      />
                                    </div>
                                  </Form.Group>
                                </Col>

                                <Col md={1} className="text-center">
                                  <span className="text-muted">OR</span>
                                </Col>

                                <Col md={6}>
                                  <Form.Group>
                                    <div className="input-icon d-flex align-items-center">
                                      <FontAwesomeIcon
                                        icon={faCube}
                                        className="icon me-2"
                                      />
                                      <Form.Control
                                        type="text"
                                        placeholder="Model Number"
                                        {...register(`products.${index}.model`)}
                                        className="user-input"
                                      />
                                    </div>
                                  </Form.Group>
                                </Col>
                              </>
                            )}

                            {(watch(`products.${index}.p_category_id`) ==
                              Category?.ContactLens ||
                              watch(`products.${index}.p_category_id`) ==
                                Category?.Lenses) && (
                              <>
                                <Col md={5}>
                                  <Form.Group>
                                    <div className="input-icon d-flex align-items-center">
                                      <FontAwesomeIcon
                                        icon={faBarcode}
                                        className="icon me-2"
                                      />
                                      <Form.Control
                                        type="text"
                                        placeholder="BO Code"
                                        {...register(
                                          `products.${index}.bo_code_product`,
                                        )}
                                        className="user-input"
                                      />
                                    </div>
                                  </Form.Group>
                                </Col>
                              </>
                            )}
                            <Col md={6}>
                              <Form.Group>
                                <div className="input-icon d-flex align-items-center">
                                  <FontAwesomeIcon
                                    icon={faCube}
                                    className="icon me-2"
                                  />
                                  <Form.Control
                                    type="text"
                                    placeholder="Product Name"
                                    {...register(`products.${index}.name`)}
                                    className="user-input"
                                  />
                                </div>
                              </Form.Group>
                            </Col>
                          </>
                        )}
                      </Row>

                      {/* Product Details */}
                      {watch(`products.${index}.product_details`) && (
                        <Row>
                          <Col className="col-lg-6 col-md-6 col-12 mb-4">
                            <div className="product-details-card shadow-sm p-3 rounded bg-white ">
                              <FontAwesomeIcon
                                className="remove_icon"
                                icon={faCircleXmark}
                                onClick={() => handleRemoveProduct(index)}
                              />
                              <div className="product-image-container  text-center">
                                <img
                                  src={
                                    IMG_URL +
                                    watch(`products.${index}.product_details`)
                                      ?.image
                                  }
                                  alt="Product"
                                  className="product-image"
                                />
                              </div>

                              <div className="product-info ">
                                {/* <p className="variant-name mb-1">
                                  {
                                    watch(`products.${index}.product_details`)
                                      ?.name
                                  }
                                </p> */}
                                <h5 className="product-name mb-2">
                                  {
                                    watch(`products.${index}.product_details`)
                                      ?.name
                                  }
                                </h5>
                                <p className="product-price mb-1">
                                  <strong>MRP:</strong> ₹{" "}
                                  {
                                    watch(`products.${index}.product_details`)
                                      ?.mrp
                                  }
                                </p>
                                {watch(`products.${index}.product_details`)
                                  ?.Stock?.model && (
                                  <p className="model-no mb-1">
                                    <strong>Model No. </strong>{" "}
                                    {
                                      watch(`products.${index}.product_details`)
                                        ?.Stock?.model
                                    }
                                  </p>
                                )}
                                {watch(`products.${index}.product_details`)
                                  ?.Stock?.barcode_no && (
                                  <p className="barcode-no mb-0">
                                    <strong>Barcode:</strong>{" "}
                                    {
                                      watch(`products.${index}.product_details`)
                                        ?.Stock?.barcode_no
                                    }
                                  </p>
                                )}
                              </div>
                            </div>
                          </Col>
                          <Col className="col-lg-6 col-md-6 col-6 mb-4">
                            <div className="product-details-card shadow-sm p-3 rounded bg-white ">
                              {watch(
                                `products.${index}.product_details.lens_details`,
                              ) ? (
                                <>
                                  <FontAwesomeIcon
                                    className="remove_icon"
                                    icon={faCircleXmark}
                                    onClick={() => handleRemoveLens(index)}
                                  />
                                  <div className="product-image-container  text-center">
                                    <img
                                      src={
                                        IMG_URL +
                                        watch(
                                          `products.${index}.product_details.lens_details`,
                                        )?.image
                                      }
                                      alt="Product"
                                      className="product-image"
                                    />
                                  </div>

                                  <div className="product-info ">
                                    <p className="variant-name mb-1">
                                      <b>Lens :</b>
                                    </p>
                                    <p className="variant-name mb-1">
                                      {
                                        watch(
                                          `products.${index}.product_details.lens_details`,
                                        )?.name
                                      }
                                    </p>
                                    <h5 className="product-name mb-2">
                                      {
                                        watch(
                                          `products.${index}.product_details.lens_details`,
                                        )?.Product_Variants?.[0]?.name
                                      }
                                    </h5>
                                    <p className="product-price mb-1">
                                      <strong>MRP:</strong> ₹{" "}
                                      {
                                        watch(
                                          `products.${index}.product_details.lens_details`,
                                        )?.mrp
                                      }
                                    </p>
                                    <p className="barcode-no mb-0">
                                      <strong>BO Code:</strong>{" "}
                                      {
                                        watch(
                                          `products.${index}.product_details.lens_details`,
                                        )?.bo_code
                                      }
                                    </p>
                                  </div>
                                </>
                              ) : (
                                <>
                                  {Number(
                                    watch(`products.${index}.p_category_id`),
                                  ) !== 4 && (
                                    <div
                                      className="no-lens-details d-flex justify-content-center align-items-center w-100"
                                      style={{ minHeight: "120px" }}
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary shadow-sm rounded-pill"
                                        // onClick={() => {
                                        //   handleAddLens(index);
                                        // setProductId(
                                        //   watch(
                                        //     `products.${index}.product_details`
                                        //   )?.id
                                        // );
                                        // }}

                                        onClick={() => {
                                          const categoryId = watch(
                                            `products.${index}.p_category_id`,
                                          );
                                          const productDetailsId = watch(
                                            `products.${index}.product_details`,
                                          )?.id;

                                          if (
                                            Number(categoryId) === 3 ||
                                            Number(categoryId) === 1
                                          ) {
                                            if (!user_id) {
                                              alert(
                                                "Please Add User Details...!",
                                              );
                                              return false;
                                            }
                                            setPrescriptionModel(true);
                                            handleprescription(index);
                                          } else {
                                            handleAddLens(index);
                                          }

                                          setProductId(productDetailsId);
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          icon={faPlus}
                                          className="me-2"
                                        />{" "}
                                        {Number(
                                          watch(
                                            `products.${index}.p_category_id`,
                                          ),
                                        ) === 3 ||
                                        Number(
                                          watch(
                                            `products.${index}.p_category_id`,
                                          ),
                                        ) === 1
                                          ? "Add Prescription"
                                          : " Add Lens"}
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          </Col>
                          {watch(
                            `products.${index}.product_details.addon_details`,
                          ) && (
                            <Col className="col-lg-6 col-md-6 col-6 mb-4">
                              <div className="product-details-card shadow-sm p-3 rounded bg-white ">
                                <>
                                  <FontAwesomeIcon
                                    className="remove_icon"
                                    icon={faCircleXmark}
                                    onClick={() => handleRemoveAdd(index)}
                                  />
                                  <div className="product-image-container  text-center">
                                    <img
                                      src={
                                        IMG_URL +
                                        watch(
                                          `products.${index}.product_details.addon_details`,
                                        )?.image
                                      }
                                      alt="Product"
                                      className="product-image"
                                    />
                                  </div>

                                  <div className="product-info ">
                                    <p className="variant-name mb-1">
                                      <b>AddOn :</b>
                                    </p>
                                    <p className="variant-name mb-1">
                                      {
                                        watch(
                                          `products.${index}.product_details.addon_details`,
                                        )?.name
                                      }
                                    </p>
                                    <h5 className="product-name mb-2">
                                      {
                                        watch(
                                          `products.${index}.product_details.addon_details`,
                                        )?.Product_Variants?.[0]?.name
                                      }
                                    </h5>
                                    <p className="product-price mb-1">
                                      <strong>Price:</strong> ₹{" "}
                                      {
                                        watch(
                                          `products.${index}.product_details.addon_details`,
                                        )?.price
                                      }
                                    </p>
                                    {/* <p className="barcode-no mb-0">
                                      <strong>BO Code:</strong>{" "}
                                      {
                                        watch(
                                          `products.${index}.product_details.addon_details`
                                        )?.Stock?.barcode_no
                                      }
                                    </p> */}
                                  </div>
                                </>
                              </div>
                            </Col>
                          )}
                        </Row>
                      )}

                      {/* Action Buttons */}
                      {index === fields.length - 1 ? (
                        <>
                          <div className="add-btn-floating">
                            <Button
                              variant="dark"
                              onClick={() =>
                                append({
                                  barcode_no: "",
                                  model: "",
                                  product_details: "",
                                })
                              }
                            >
                              <FontAwesomeIcon icon={faPlus} className="me-2" />
                              Add Product
                            </Button>
                            {fields.length > 1 && (
                              <Button
                                variant="danger"
                                onClick={() => remove(index)}
                              >
                                <FontAwesomeIcon
                                  icon={faTrash}
                                  className="me-2"
                                />
                                Remove
                              </Button>
                            )}
                          </div>
                        </>
                      ) : (
                        <>
                          <Button
                            variant="danger"
                            className="add-btn-floating"
                            onClick={() => remove(index)}
                          >
                            <FontAwesomeIcon icon={faTrash} className="me-2" />
                            Remove
                          </Button>
                        </>
                      )}
                    </div>
                  </Col>
                </Row>
              ))}
            </Form>
          </section>
        </Col>
        <Col md={4}>
          <Summary
            prescription={prescription}
            useWatch={useWatch}
            control={control}
            user_id={user_id}
            getValues={getValues}
            watch={watch}
            setValue={setValue}
          />
        </Col>
      </Row>

      <Lense_prescription_modal
        user_id={user_id}
        setPrescription={setPrescription}
        // lenseTypeId={lenseTypeId}
        productId={productId}
        handleAddLens={handleAddLens}
        // lenseId={lenseId}
        // addOnId={addOnId}
        show={PrescriptionModel}
        onHide={() => setPrescriptionModel(false)}
        setValueMain={setValue}
        index={lensIndex}
        getValues={getValues}
        watch={watch}
        register={register}
        setLensIndex={setLensIndex}
      />
      <LensModal
        user_id={user_id}
        setPrescription={setPrescription}
        productId={productId}
        show={lensModalShow}
        onHide={() => setLensModalShow(false)}
        setValue={setValue}
        index={lensIndex}
        getValues={getValues}
        watch={watch}
        register={register}
        setLensIndex={setLensIndex}
      />
    </>
  );
}

export default Product;
